/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgComponentContent = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M5 19v2H3v-2h2zm16 0v2h-2v-2h2zM9.001 19v2H7v-2h2.001zM13 19v2h-2v-2h2zm4.001 0v2H15v-2h2.001zM5 14.999V17H3v-2.001h2zm16 0V17h-2v-2.001h2zM13 7v3.586l1.293-1.293 1.414 1.414L12 14.414l-3.707-3.707 1.414-1.414L11 10.586V7h2zm-8 4v2H3v-2h2zm16 0v2h-2v-2h2zM5 6.999V9H3V6.999h2zm16 0V9h-2V6.999h2zM9.001 3v2H7V3h2.001zM5 3v2H3V3h2zm8 0v2h-2V3h2zm4.001 0v2H15V3h2.001zM21 3v2h-2V3h2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgComponentContent as ComponentContent };
